module.exports = __webpack_public_path__ + "static/media/react.0c1adc6b.png";